import { notify } from '../../components/Notifications';

const GENERIC_ERROR_MSG = 'Try refreshing the page.';

async function makeRequest({
  request,
  requestParams,
  showErrorNotification




}) {
  try {
    const { data, errors } = await request(requestParams);

    const isError = errors && errors.length;

    if (isError && showErrorNotification) {
      notify({ type: 'error', content: GENERIC_ERROR_MSG });
    }

    return { data, error: isError ? GENERIC_ERROR_MSG : void 0 };
  } catch (err) {
    if (showErrorNotification) {
      notify({ type: 'error', content: GENERIC_ERROR_MSG });
    }

    return { error: GENERIC_ERROR_MSG };
  }
}

export default makeRequest;